import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { NotificationComponent } from 'src/app/shared/components/notification/notification.component';
import { UserDataService } from 'src/app/shared/services/user-data.service';
import { DietData } from './diet.data';
import { take } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/compat/storage';

@Component({
  selector: 'app-diet-questionnaire',
  templateUrl: './diet-questionnaire.component.html',
  styleUrls: ['./diet-questionnaire.component.scss'],
})
export class DietQuestionnaireComponent implements OnInit {
  isFormSubmitted = false;
  personalInfo: FormGroup = this.fb.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['@gmail.com', [Validators.required, Validators.email]],
    country: ['', Validators.required],
    city: ['', Validators.required],
    phoneNumber: [null, [Validators.required, Validators.maxLength(12)]],
    age: ['', Validators.required],
    gender: ['', Validators.required],
    maritalStatus: ['', Validators.required],
    occupation: ['', Validators.required],
    package: [],
    packageAmnt: [],
  });

  bodyMeasure: FormGroup = this.fb.group({
    height: ['', Validators.required],
    weight: ['', Validators.required],
    bust: [],
    waist: [],
    hips: [],
    bmi: [{ value: 0, disabled: true }],
  });

  healthIssues: FormGroup = this.fb.group({
    dailyActivity: ['', Validators.required],
    medicalCondition: [''],
    medicalHistory: [],
    aboutMedication: [''],
    medicalReports: [],
    dietHabits: ['', Validators.required],
    dietHabitsOther: [''],
    mealPrefer: ['', Validators.required],
    mealOther: [''],
    cuisinesPrefer: ['', Validators.required],
    cuisinesOther: [''],
    foodAllergy: [],
  });

  dailyRoutine: FormGroup = this.fb.group({
    breakfast: ['', Validators.required],
    breakfastTime: [],
    lunch: ['', Validators.required],
    lunchTime: [''],
    dinner: ['', Validators.required],
    dinerTime: [],
    midMealSnacks: [''],
    midMealSnacksTime: [],
    workoutRoutine: [''],
    otherDiet: [],
    wakeupTime: [''],
    startWorkTime: [],
    endWorkTime: [],
    housewifeRoutine: [''],
    weekends: [],
    anything: [],
    sleepHours: [8, Validators.required],
  });

  miscelleneous: FormGroup = this.fb.group({
    healthGowl: ['', Validators.required],
    writeAnything: ['', Validators.required],
    modeOfCommunication: [''],
    modeOfCommunicationOther: [''],
  });

  saveIcon = '../../../assets/images/bookmark.png';
  backIcon = '../../../assets/images/arrow-left.png';
  nextIcon = '../../../assets/images/next (1).png';
  submitIcon = '../../../assets/images/submit (2).png';
  happyIcon = '../../../assets/images/relax.jpg';
  modeOfCommunication = DietData.COMMUNICATION_MODE;
  otherDiet = DietData.PARTICULAR_DIET;
  workoutRoutine = DietData.WORKOUT_ROUTINE;
  cuisinesPrefer = DietData.CUISINES_PREFER;
  mealPrefer = DietData.MEALS_PREFER;
  dietHabits = DietData.DIET_HABITS;
  dailyActivity = DietData.DAILY_ACTIVITY_DATA;
  medicalCondition = DietData.MEDICAL_CONDITION;
  marital = DietData.MARITAL_DATA;
  dietHabitsOther: boolean = false;
  mealOther: boolean = false;
  cuisinesOther: boolean = false;
  modeOfCommunicationOther: boolean = false;
  userUID: string | undefined;
  invalidForm: boolean = false;
  filePath!: string;
  constructor(
    private fb: FormBuilder,
    private firestore: AngularFirestore,
    private auth: AngularFireAuth,
    private snackbar: MatSnackBar,
    private route: ActivatedRoute,
    private userDataService: UserDataService,
    private storage: AngularFireStorage
  ) {
    this.userUID = this.userDataService.userUID;
    this.filePath = `customer-documents/reports/${this.userUID}/`;
  }

  ngOnInit(): void {
    const fileRef = this.storage.ref(this.filePath);
    fileRef.getDownloadURL().subscribe((data) => console.log(data));
    this.healthIssues.controls['dietHabits'].valueChanges.subscribe((data) => {
      if (data.find((x: any) => x === 'Other')) this.dietHabitsOther = true;
    });
    this.healthIssues.controls['mealPrefer'].valueChanges.subscribe((data) => {
      if (data.find((x: any) => x === 'Other')) this.mealOther = true;
    });
    this.healthIssues.controls['cuisinesPrefer'].valueChanges.subscribe(
      (data) => {
        if (data.find((x: any) => x === 'Other')) this.cuisinesOther = true;
      }
    );
    this.miscelleneous.controls['modeOfCommunication'].valueChanges.subscribe(
      (data) => {
        if (data.find((x: any) => x === 'Other'))
          this.modeOfCommunicationOther = true;
      }
    );
    this.bodyMeasure.controls['height'].valueChanges.subscribe((data) => {
      this.calculateBMI();
    });

    this.bodyMeasure.controls['weight'].valueChanges.subscribe((data) => {
      this.calculateBMI();
    });

    this.getSavedForms();
    this.calculateBMI();
  }

  getSavedForms() {
    this.getClientProfile();
    this.getPersonalInfo();
    this.getBodyMeasure();
    this.getHealthIssues();
    this.getDailyRoutine();
    this.getOtherDetails();
  }

  getClientProfile() {
    this.firestore
      .collection('clientProfile')
      .doc(this.userUID)
      .get()
      .pipe(take(1))
      .subscribe((data: any) => {
        if (data.data()) {
          this.personalInfo.patchValue({
            firstName: data.data().firstName,
            lastName: data.data().lastName,
            email: data.data().email,
            phoneNumber: data.data().phoneNumber,
            package: data.data().package,
            packageAmnt: data.data().packageAmnt,
          });
        }
      });
  }

  getPersonalInfo() {
    this.firestore
      .collection('personalInfo')
      .doc(this.userUID)
      .get()
      .pipe(take(1))
      .subscribe((data: any) => {
        this.personalInfo.setValue(data.data());
      });
  }

  getBodyMeasure() {
    this.firestore
      .collection('bodyMeasure')
      .doc(this.userUID)
      .get()
      .pipe(take(1))
      .subscribe((data: any) => {
        this.bodyMeasure.setValue(data.data());
      });
  }

  getHealthIssues() {
    this.firestore
      .collection('healthIssues')
      .doc(this.userUID)
      .get()
      .pipe(take(1))
      .subscribe((data: any) => {
        this.healthIssues.setValue(data.data());
      });
  }

  getDailyRoutine() {
    this.firestore
      .collection('dailyRoutine')
      .doc(this.userUID)
      .get()
      .pipe(take(1))
      .subscribe((data: any) => {
        this.dailyRoutine.setValue(data.data());
      });
  }

  getOtherDetails() {
    this.firestore
      .collection('miscelleneous')
      .doc(this.userUID)
      .get()
      .pipe(take(1))
      .subscribe((data: any) => {
        this.miscelleneous.setValue(data.data());
      });
  }

  selectTime(time: any, label: string) {
    switch (label) {
      case 'lunchTime':
        this.dailyRoutine.get(label)?.setValue(time);
        break;
      case 'dinnerTime':
        this.dailyRoutine.get(label)?.setValue(time);
        break;
      case 'breakfastTime':
        this.dailyRoutine.get(label)?.setValue(time);
        break;
      case 'midMealSnacksTime':
        this.dailyRoutine.get(label)?.setValue(time);
        break;
      case 'wakeupTime':
        this.dailyRoutine.get(label)?.setValue(time);
        break;
      case 'startWorkTime':
        this.dailyRoutine.get(label)?.setValue(time);
        break;
      case 'endWorkTime':
        this.dailyRoutine.get(label)?.setValue(time);
        break;
      default:
        console.log('Invalid label');
    }
  }

  onSubmit(formName: string) {
    this.savePersonalInfo('personalInfo');
  }

  saveForm(formName: string) {
    // this.validatePhNum();
    if (formName === 'personalInfo') {
      this.savePersonalInfo(formName, true);
    } else if (formName === 'bodyMeasure') {
      this.saveBodyMeasure(formName, true);
    } else if (formName === 'healthIssues') {
      this.saveHealthIssues(formName), true;
    } else if (formName === 'dailyRoutine') {
      this.saveDailyRoutine(formName, true);
    } else if (formName === 'miscelleneous') {
      this.saveMiscelleneous(formName, true);
    }
  }

  savePersonalInfo(formName: string, isSave?: boolean) {
    if (this.personalInfo.invalid) {
      this.invalidForm = true;
      this.formError(
        'Please  fill all the mandatory fields in personal details which are marked with astrisk (*)'
      );
      return;
    } else this.invalidForm = false;

    this.firestore
      .collection(formName)
      .doc(this.userUID)
      .set(this.personalInfo.getRawValue())
      .then((data) => {
        if (isSave) {
          this.snackbar.openFromComponent(NotificationComponent, {
            data: {
              customMsg: 'Personal Info Saved Successfully.',
              type: 'success',
            },
          });
        }

        this.saveBodyMeasure('bodyMeasure');
        // this.isLoading = false;
        // this.clearInputMethod();
      })
      .catch((error) => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: error.message,
            type: 'error',
          },
        });
        // this.isLoading = false;
      });
  }

  saveBodyMeasure(formName: string, isSave?: boolean) {
    if (this.bodyMeasure.invalid) {
      this.invalidForm = true;
      this.formError(
        'Please  fill all the mandatory fields in body measurements which are marked with astrisk (*)'
      );
      return;
    } else this.invalidForm = false;

    this.firestore
      .collection(formName)
      .doc(this.userUID)
      .set(this.bodyMeasure.getRawValue())
      .then((data) => {
        if (isSave) {
          this.snackbar.openFromComponent(NotificationComponent, {
            data: {
              customMsg: 'Body Measurement Saved Successfully.',
              type: 'success',
            },
          });
        }

        this.saveHealthIssues('healthIssues');
        // this.isLoading = false;
        // this.clearInputMethod();
      })
      .catch((error) => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: error.message,
            type: 'error',
          },
        });
        // this.isLoading = false;
      });
  }

  saveHealthIssues(formName: string, isSave?: boolean) {
    if (this.healthIssues.invalid) {
      this.invalidForm = true;
      this.formError(
        'Please  fill all the mandatory fields in health issues which are marked with astrisk (*)'
      );
      return;
    } else this.invalidForm = false;
    this.firestore
      .collection(formName)
      .doc(this.userUID)
      .set(this.healthIssues.getRawValue())
      .then((data) => {
        if (isSave) {
          this.snackbar.openFromComponent(NotificationComponent, {
            data: {
              customMsg: 'Health Issues Saved Successfully.',
              type: 'success',
            },
          });
        }

        this.saveDailyRoutine('dailyRoutine');
        // this.isLoading = false;
        // this.clearInputMethod();
      })
      .catch((error) => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: error.message,
            type: 'error',
          },
        });
        // this.isLoading = false;
      });
  }

  saveDailyRoutine(formName: string, isSave?: boolean) {
    if (this.dailyRoutine.invalid) {
      this.invalidForm = true;
      this.formError(
        'Please  fill all the mandatory fields in daily routine which are marked with astrisk (*)'
      );
      return;
    } else this.invalidForm = false;
    this.firestore
      .collection(formName)
      .doc(this.userUID)
      .set(this.dailyRoutine.getRawValue())
      .then((data) => {
        if (isSave) {
          this.snackbar.openFromComponent(NotificationComponent, {
            data: {
              customMsg: 'Daily Routine Saved Successfully.',
              type: 'success',
            },
          });
        }

        this.saveMiscelleneous('miscelleneous');
        // this.isLoading = false;
        // this.clearInputMethod();
      })
      .catch((error) => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: error.message,
            type: 'error',
          },
        });
        // this.isLoading = false;
      });
  }

  saveMiscelleneous(formName: string, isSave?: boolean) {
    if (this.miscelleneous.invalid) {
      this.invalidForm = true;
      this.formError(
        'Please  fill all the mandatory fields in miscelleneous which are marked with astrisk (*)'
      );
      return;
    } else this.invalidForm = false;

    this.firestore
      .collection(formName)
      .doc(this.userUID)
      .set(this.miscelleneous.getRawValue())
      .then((data) => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: 'Questionnaire submitted successfully.',
            type: 'success',
          },
        });
        if (!this.invalidForm) {
          this.updateClientStatus();
          this.isFormSubmitted = true;
        }
        // this.clearInputMethod();
      })
      .catch((error) => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: error.message,
            type: 'error',
          },
        });
        // this.isLoading = false;
      });
  }

  updateClientStatus() {
    const document = this.firestore
      .collection('clientProfile')
      .doc(this.userUID);
    const data = document.update({ status: 'Not Started' }).then(() => {
      console.log('Client status updated successfully');
    });
  }

  calculateBMI() {
    let height: any = this.bodyMeasure.get('height');
    let weight: any = this.bodyMeasure.get('weight');
    if (height.value !== '' && weight.value !== '') {
      height = Number(height.value);
      weight = Number(weight.value);
      const inches = (height * 10) % 10;
      const feet = (height * 10 - inches) / 10;
      height = ((feet * 12 + inches) * 2.54) / 100;

      const BMI = weight / (height * height);
      this.userDataService.setBMI(BMI.toFixed(2));
      this.bodyMeasure.controls['bmi']?.setValue(BMI.toFixed(2));
    }
  }

  formError(msg: string) {
    this.snackbar.openFromComponent(NotificationComponent, {
      data: {
        customMsg: msg,
        type: 'error',
      },
    });
  }
}
